// These functions are here to serve as fast + loose substitutes for common jQuery utils.

export function removeElementById(elementId) {
	const el = document.getElementById(elementId);

	if (!el) {
		return;
	}

	el.parentNode.removeChild(el);
}

export function hideElementById(elementId) {
	const el = document.getElementById(elementId);

	if (!el) {
		return;
	}

	el.style.display = "none";
}

export function showElementById(elementId) {
	const el = document.getElementById(elementId);

	if (!el) {
		return;
	}

	el.style.display = "block";
}

export function templateStringToElement(string) {
	// An HTML5 template element would better here, but no IE support.
	const div = document.createElement("div");

	div.innerHTML = string;

	return div.firstChild;
}

// [[[ --------------------------------------------------------------------------
//  Helper function; allows us to insert an iframe in a div anywhere
//  and then refer to it like so:
//
//   var ifr = IFrameInsertedAt(document.body);
//   ifr.doc.createElement("script")
//   etc.
// ----------------------------------------------------------------------------]]]

export function IFrameInsertedAt(parentElement = document.body) {
	const iframe = document.createElement("iframe");
	parentElement.appendChild(iframe);
	iframe.doc = null;

	// Firefox, Opera
	if (iframe.contentDocument) {
		iframe.doc = iframe.contentDocument;
	}

	// Internet Explorer
	else if (iframe.contentWindow) {
		iframe.doc = iframe.contentWindow.document;
	}

	// Others?
	else if (iframe.document) {
		iframe.doc = iframe.document;
	}

	if (iframe.doc == null) {
		throw new Error("Document not found, append the parent element to the DOM before creating the IFrame");
	}

	// Create the script inside the iframe's document which will call the
	iframe.doc.open();
	iframe.doc.close();

	return iframe;
}



// WEBPACK FOOTER //
// ./src/shared/util/query_util.js